import React, { Fragment, useEffect, useState } from 'react';
import {
    Row, Col,
    Modal, ModalHeader, ModalBody, ModalFooter, Label, Button, Card, CardBody, Badge,Table
} from "reactstrap";
import TicketModal from './ticket-modal';
import ViewPolicyModal from '../../sales/policies/view-policy-details/view-policy-modal';
import PolicyCancellationModal from './policy-cancellation-request-modal-back'
import { Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap'
import TicketHistory from './TicketHistory';
import PolicyEditRequestModalStep from './policyEditRequestModal';

const PolicyEditRequestModal = (props) => {
    const [policyData, setPolicyData] = useState(null);
    const [salesPolicyId, setSalesPolicyId] = useState("");
    const { isOpen , toggle, rowData} = props;

    useEffect(() => {
      if (rowData?.payload) {
          const payloadData = JSON.parse(rowData.payload);
          const policyNo = payloadData?.reject?.updateCriteria?.certificate;
          setPolicyData(policyNo);
          const sales_policy_id = payloadData?.reject?.updateCriteria?.sales_policy_id;
          setSalesPolicyId(sales_policy_id);
        //   console.log("payloadData", payloadData)
      }
    }, [rowData]);
    
    const [viewPolicyDetailspModal, setPolicyDetailsModal] = useState(false);
    const togglePolicyDetailsModal = () => setPolicyDetailsModal(!viewPolicyDetailspModal);

    const viewPolicyDetailsModal = () => {
        togglePolicyDetailsModal();
    };


    const [viewPolicyDetailsByType, setViewPolicyDetailsByType] = useState(0);
    const [productData, setProductData] = useState({});
    const steps = [
        { key: 0, name: 'Policy Edit', component: <PolicyEditRequestModalStep rowData={rowData} isHistoryTabTrigger={props.isHistoryTabTrigger}/> },
        { key: 1, name: 'History', component: <TicketHistory data={rowData}/> },
        // { key: 2, name: 'Validity (in Days)', component: <Validity data={selectedProductData} /> }
    ]

    const handleNextTabByClick = (nextStepValue, steps) => {
        if (nextStepValue < steps.length) {
            setViewPolicyDetailsByType(viewPolicyDetailsByType + 1);
        }
    }

    const handlePreviousTabByClick = (previousStepValue, steps) => {
        if (previousStepValue >= 0) {
            setViewPolicyDetailsByType(viewPolicyDetailsByType - 1);
        }
    }



    return (
        <Fragment>
        <Modal isOpen={isOpen} toggle={toggle} size="lg"   backdrop="static">
                <ModalHeader toggle={toggle} className="pb-0 border-0">
                    {"Request Details"}
                </ModalHeader>
                <ModalBody className="pt-4">
                    <Nav className="nav-pills nav-justified">
                        {
                            steps && steps.map((item, i) => {
                                return (
                                    <NavItem key={i}>
                                        <NavLink href="#javascript" className={viewPolicyDetailsByType === item.key ? 'active' : ''} onClick={() => setViewPolicyDetailsByType(item.key)}>
                                            <span style={{ whiteSpace: 'nowrap' }}> {item.name} </span>
                                        </NavLink>
                                    </NavItem>
                                )
                            })
                        }
                    </Nav>
                    <TabContent activeTab={viewPolicyDetailsByType}>
                        {
                            steps && steps.map((item, i) => {
                                return (
                                    <TabPane className={item.key === 0 ? "fade show" : ""} tabId={item.key} key={i}>
                                        {item.component}
                                    </TabPane>
                                )
                            })
                        }
                    </TabContent>
                </ModalBody>
                {/* <ModalFooter>
                    <div className="container-fluid">
                        <div className="row">
                        <div className="col-6">
                        {parseInt(viewPolicyDetailsByType) !== 0 && (
                            <Button
                            className="mr-2 btnCustom"
                            outline
                            color="info"
                            size="md"
                            onClick={(e) => handlePreviousTabByClick(parseInt(viewPolicyDetailsByType) - 1, steps)}
                            >
                            {"Previous"}
                            </Button>
                            )}
                        </div>
                        <div className="col-6 text-right">
                            {parseInt(viewPolicyDetailsByType) < 2 && (
                            <Button
                                className="btnCustom"
                                outline
                                color="info"
                                size="md"
                                onClick={(e) => handleNextTabByClick(parseInt(viewPolicyDetailsByType) + 1, steps)}
                            >
                                {"Next"}
                            </Button>
                            )}
                        </div>
                        </div>
                    </div>
                    </ModalFooter> */}
            </Modal>
        </Fragment>
    );

}

export default PolicyEditRequestModal;